export const PAGE_ID = {
  HOME: '홈_해외',
  CATEGORY: '해외카테고리',
  SEARCH: '해외검색',
  SEARCH_RESULT: '해외검색결과',
  SEARCH_RESULT_EMPTY: '해외검색결과_결과없음',
  PRODUCT: '상품상세',
  PRODUCT_COUPON_DOWNLOAD_BOTTOM_SHEET: '상품상세_쿠폰받기_바텀시트',
  SHOP:'해외상점상세'
} as const;

export const VIEW_ID = {
  PRODUCT: '해외상품',
  RECOMMEND_PRODUCTS: '해외추천상품',
  SEARCH_PRODUCT: '검색상품',
  TOP_BANNER: '탑배너',
  MIDDLE_BANNER: '미들배너',
  EXHIBITION_BANNER: '기획전배너',
  TOP: '상단',
  BOTTOM: '하단',
  DOWNLOAD_COUPON: '쿠폰받기',
} as const;

export const BUTTON_ID = {
  PRODUCT_TAB: {
    ['info']: '상품정보',
    ['guide']: '구매가이드',
    ['review']: '후기',
  },
  SHORT_CUT: '숏컷',
  POPULAR_CATEGORY: '인기카테고리',
  VIEW_ORIGINAL_TEXT: '원문보기',
  SHARE: '공유',
  SEARCH_SHORT_CUT: '검색숏컷',
  RANKED_KEYWORD: '인기검색어',
  MERCARI_SHOP_PROFILE: '메루카리상점프로필',
  COUPON:'쿠폰',
  COUPON_DOWNLOAD:'쿠폰받기'
} as const;

export const CONTENT_TYPE = {
  MERCARI: 'mercari',
  CATEGORY: 'category',
  BANNER: 'banner',
} as const;

export const EVENT_TYPE = {
  VISIT: 'visit',
  SEARCH: 'search',
  SELECT: 'select',
  SELECT_PRODUCT: 'select_product',
  SELECT_BANNER: 'select_banner',
  
  IMPRESSION: 'impression',
  EXPOSURE: 'exposure',
  WISHLIST: 'wishlist',
  VIEW: 'view',
  SEARCH_REQUEST: 'search_request',
  SEARCH_RESPONSE: 'search_response',
} as const;

export const EVENT_ACTION = {
  VISIT: 'visit',
  SEARCH: 'search',
  
  SELECT_PRODUCT: 'select_product',
  SELECT_BUTTON: 'select_button',
  SELECT_BANNER: 'select_banner',
  IMPRESSION: 'impression',
  EXPOSURE_BANNER: 'exposure_banner',
  ADD_TO_WISHLIST: 'add_to_wishlist',
  REMOVE_FROM_WISHLIST: 'remove_from_wishlist',
  VIEW_CONTENT: 'view_content',
  SEARCH_REQUEST: 'search_request',
  SEARCH_RESPONSE: 'search_response',
} as const;
